let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("76okG")).then(() => parcelRequire('9Qguw'));